import React from 'react';
import Header from '../Header';
import NavMenuDivider from '../../../NavMenuDivider';
import { Content } from './Content';
export var Layout = function Layout(_ref) {
  var currentProduct = _ref.currentProduct,
      environment = _ref.environment,
      features = _ref.features,
      inverted = _ref.inverted,
      onLinkClick = _ref.onLinkClick,
      onReloadHandler = _ref.onReloadHandler,
      swicusOrgId = _ref.swicusOrgId,
      onShowFeedbackModal = _ref.onShowFeedbackModal;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Header, {
    inverted: inverted
  }), /*#__PURE__*/React.createElement(NavMenuDivider, null), /*#__PURE__*/React.createElement(Content, {
    currentProduct: currentProduct,
    environment: environment,
    features: features,
    inverted: inverted,
    onLinkClick: onLinkClick,
    onReloadHandler: onReloadHandler,
    swicusOrgId: swicusOrgId,
    onShowFeedbackModal: onShowFeedbackModal
  }));
};